<template>
  <div>
    <Header :title="$t('m.InTheMeeting')"></Header>
    <div class="serch">
      <span>{{$t('m.ConferenceTerminal')}}</span>
      ({{this.terminal_on+'/'+this.terminal_total}})
      <span style="float:right">
        <span :class="this.$store.state.Sreenstatus?'serchbox':'lanceserchbox'">
          <Icon type="ios-search"></Icon>
          <input
            @input="toGetForthMeeting"
            class="searchinput"
            :placeholder="$t('m.PlsInputSearchTerminal')"
            type="text"
            v-model="searchcontent"
          />
        </span>
      </span>
    </div>
    <div :style=" this.$store.state.Sreenstatus?'height:0.52rem':'height:0.4rem'"></div>
    <div class="peoplelist">
      <div :key="index" class="row spebgc" v-for="(item,index) in cfparty">
        <img
          :src="item.connection_status=='connected'&&item.audioSelfMuted?Muted:item.connection_status=='connected'?unLineimg:img"
          class="head"
        />
        <el-tooltip :content="item.partyNameInWeMeet" effect="dark" placement="top">
          <span
            :index="item.partyIdInWeMeet"
            class="name forindex wcolor"
          >{{item.partyNameInWeMeet }}</span>
        </el-tooltip>
        <div class="operate">
          <span v-if="item.supervisor==false">
            <span
              @click="stopDoubleStream(item)"
              :class="{imgicon:true, cycle:(item.doubleCurrent == 'true'&&item.contentProvider==false), cycleing:(item.contentProvider==true)}"
            ></span>
            <span
              v-if="item.connection_status =='connected'"
              :class="{imgicon:true, people:true,
             man:(item.callroll!='callrollmain'),
             chair:(item.callroll=='callrollmain')}"
              @click="setMeeting(item.callroll,item)"
            ></span>
            <span
              v-if="item.connection_status =='connected' && !item.onVces"
              :class="{imgicon:true, people:true,
             no:(item.callroll=='notcallroll'||item.callroll=='callrollmain'||(item.callroll=='conferencecallrolled'&&Trmenalcallroll==false)),
             ing:(item.callroll=='callrolling'),
             over:(item.callroll=='conferencecallrolled'&&Trmenalcallroll==true)
             }"
              @click="callRoll(item.callroll,item)"
            ></span>
          </span>
          <span
            v-if="item.connection_status =='connected' && !item.onVces"
            :class="{imgicon:true,video:true,no:(item.videoMuted)}"
            @click="toVideo(item)"
          ></span>
          <span
            v-if="item.connection_status =='connected'"
            :class="{imgicon:true,voice:true,no:(item.audioMuted)}"
            @click="toRadio(item)"
          ></span>
          <span
            v-if="item.connection_status == 'connecting' || item.connection_status == 'secondary'"
            :class="{imgicon:true, hangupStatus:true,connecting:(item.connection_status=='connecting')}"
          ></span>
          <span
            v-else
            @click="toHangUp(item)"
            :class="{imgicon:true, hangupStatus:true,no:(item.connection_status=='disconnected')}"
          ></span>
          <span @click="toOverAct(item.partyIdInWeMeet,item)" class="imgicon delete"></span>
        </div>
      </div>
      <div style="height:2rem"></div>
    </div>
    <div :class="this.$store.state.Screenstatus?'bottom':'Bottom'">
      <div
        :style="{'margin-left':move?'-100%':0}"
        :class="this.$store.state.Screenstatus?'b_content':'B_content'"
        id="content"
      >
        <div :class=" this.$store.state.Screenstatus?'bleft':'Bleft'">
          <div @click="addpeople" :class=" this.$store.state.Screenstatus?'bitem':'Bitem'">
            <img
              :src="imgpath.control_adduser"
              alt
              :class="this.$store.state.Screenstatus?'bitemimg_new':'Bitemimg_new'"
            />
            <span class="bfont">{{$t('m.AddUser')}}</span>
          </div>
          <div @click="addterminal" :class=" this.$store.state.Screenstatus?'bitem':'Bitem'">
            <img
              :src="imgpath.control_addterminal"
              alt
              :class="this.$store.state.Screenstatus?'bitemimg_new':'Bitemimg_new'"
            />
            <span class="bfont">{{$t('m.AddTerminal')}}</span>
          </div>
          <div
            @touchstart="screenshow=true;layouttype=oldlayouttype;"
            :class=" this.$store.state.Screenstatus?'bitem':'Bitem'"
             v-if="!this.vcesOnlyMeeting"
          >
            <img
              :src="imgpath.control_splitscreen"
              alt
              :class="this.$store.state.Screenstatus?'bitemimg_new':'Bitemimg_new'"
            />
            <span class="bfont">{{$t('m.LayoutMode')}}</span>
          </div>
          <div v-if="!vcesOnlyMeeting" @click="broadcastShowAct" :class=" this.$store.state.Screenstatus?'bitem':'Bitem'">
            <img
              :src="guangbo ? imgpath.control_broadcastno : imgpath.control_broadcast"
              alt
              :class="this.$store.state.Screenstatus?'bitemimg_new':'Bitemimg_new'"
            />
            <span class="bfont">{{$t('m.OneKeyBroadcast')}}</span>
          </div>
          <div @click="toRadioAll()" :class=" this.$store.state.Screenstatus?'bitem':'Bitem'">
            <img
              :src="radio=='true' ? imgpath.control_novoice : imgpath.control_audiocontrol"
              alt
              :class="this.$store.state.Screenstatus?'bitemimg_new':'Bitemimg_new'"
            />
            <span class="bfont">{{$t('m.AudioControl')}}</span>
          </div>
          <div v-if="!vcesOnlyMeeting" @click="toVideoAll()" :class=" this.$store.state.Screenstatus?'bitem':'Bitem'">
            <img
              :src="video=='true' ? imgpath.control_novideo : imgpath.control_videocontrol"
              alt
              :class="this.$store.state.Screenstatus?'bitemimg_new':'Bitemimg_new'"
            />
            <span class="bfont">{{$t('m.VideoControl')}}</span>
          </div>
          <div @click="doublestream" :class=" this.$store.state.Screenstatus?'bitem':'Bitem'">
            <img
              :src="imgpath.control_doublestream"
              alt
              :class="this.$store.state.Screenstatus?'bitemimg_new':'Bitemimg_new'"
            />
            <span class="bfont">{{$t('m.DualStreamFunction')}}</span>
          </div>
          <div @click="toLock" :class=" this.$store.state.Screenstatus?'bitem':'Bitem'">
            <img
              :src="conference_locked=='false' ? imgpath.control_lock : imgpath.control_locked"
              alt
              :class="this.$store.state.Screenstatus?'bitemimg_new':'Bitemimg_new'"
            />
            <span class="bfont">{{$t('m.MeetingLock')}}</span>
          </div>
          <template v-if="vcesOnlyMeeting">
            <div
              @click="templatenameshow=true"
              :class=" this.$store.state.Screenstatus?'bitem':'Bitem'"
            >
              <img
                :src="imgpath.control_template"
                alt
                :class="this.$store.state.Screenstatus?'bitemimg_new':'Bitemimg_new'"
              />
              <span class="bfont">{{$t('m.SaveAs')}}</span>
            </div>
            <div @click="checkinrecords" :class=" this.$store.state.Screenstatus?'bitem':'Bitem'">
              <img
                :src="imgpath.control_checkinrecords"
                alt
                :class="this.$store.state.Screenstatus?'bitemimg_new':'Bitemimg_new'"
              />
              <span class="bfont">{{$t('m.CheckinRecord')}}</span>
            </div>
            <div @click="exitsure=true" :class=" this.$store.state.Screenstatus?'bitem':'Bitem'">
              <img
                :src="imgpath.control_close"
                alt
                :class="this.$store.state.Screenstatus?'bitemimg_new':'Bitemimg_new'"
              />
              <span class="bfont">{{$t('m.MeetingEnd')}}</span>
            </div>
          </template>
        </div>
        <div :class=" this.$store.state.Screenstatus?'bright':'Bright'" v-if="!vcesOnlyMeeting">
          <div
            @click="templatenameshow=true"
            :class=" this.$store.state.Screenstatus?'bitem':'Bitem'"
          >
            <img
              :src="imgpath.control_template"
              alt
              :class="this.$store.state.Screenstatus?'bitemimg_new':'Bitemimg_new'"
            />
            <span class="bfont">{{$t('m.SaveAs')}}</span>
          </div>
          <div
            @click="shareplaysure=true"
            :class=" this.$store.state.Screenstatus?'bitem':'Bitem'"
            v-show="showRecordAndLive"
          >
            <img
              :src="imgpath.control_liveshare"
              alt
              :class="this.$store.state.Screenstatus?'bitemimg_new':'Bitemimg_new'"
            />
            <span class="bfont">{{$t('m.LiveShare')}}</span>
          </div>
          <div
            @click="toRecord(cf_record)"
            :class=" this.$store.state.Screenstatus?'bitem':'Bitem'"
            v-show="showRecordAndLive"
          >
            <img
              :src="cf_record==2 ? imgpath.control_recordstop :cf_record==4?imgpath.control_recording: imgpath.control_recordstart"
              :class="this.$store.state.Screenstatus?'bitemimg_new':'Bitemimg_new'"
            />
            <span class="bfont">{{$t('m.ConferenceRecord')}}</span>
          </div>
          <div
            @click="toRecord(3)"
            :class=" this.$store.state.Screenstatus?'bitem':'Bitem'"
            v-show="cf_record!=1&&showRecordAndLive"
          >
            <img
              :src="imgpath.control_recordover"
              :class="this.$store.state.Screenstatus?'bitemimg_new':'Bitemimg_new'"
            />
            <span class="bfont">{{$t('m.RecordEnd')}}</span>
          </div>
          <div @click="checkinrecords" :class=" this.$store.state.Screenstatus?'bitem':'Bitem'">
            <img
              :src="imgpath.control_checkinrecords"
              alt
              :class="this.$store.state.Screenstatus?'bitemimg_new':'Bitemimg_new'"
            />
            <span class="bfont">{{$t('m.CheckinRecord')}}</span>
          </div>
          <div @click="exitsure=true" :class=" this.$store.state.Screenstatus?'bitem':'Bitem'">
            <img
              :src="imgpath.control_close"
              alt
              :class="this.$store.state.Screenstatus?'bitemimg_new':'Bitemimg_new'"
            />
            <span class="bfont">{{$t('m.MeetingEnd')}}</span>
          </div>
        </div>
      </div>
      <div v-if='!this.vcesOnlyMeeting'>
        <div class="pointtwo" v-if="this.$store.state.Screenstatus">
          <span :class="{bgc:!move}" class="divpoint"></span>
          <span :class="{bgc:move}" class="divpoint"></span>
        </div>
        <div class="lancepointtwo" v-else>
          <span :class="{bgc:!move}" class="lancedivpoint"></span>
          <span :class="{bgc:move}" class="lancedivpoint"></span>
        </div>
      </div>
    </div>
    <div class="pop" v-if="screenshow">
      <div class="popwarp">
        <div class="popcontent">
          <div class="poptitle">{{$t('m.LayoutMode')}}</div>
          <RadioGroup v-model="layouttype">
            <div class="screenpopmain">
              <div :key="index" class="screenpopmainitem" v-for="(item,index) in screen">
                <div class="screenimg"></div>
                <div class="screenfont">{{item}}</div>
                <div class="screenradio">
                  <input v-model="layouttype" :value="(index+1)" name="screen" type="radio" />
                </div>
              </div>
            </div>
          </RadioGroup>
          <div class="popfooter">
            <div @click="toLayout" class="left bgc">{{$t('m.SaveBtn')}}</div>
            <div @click="screenshow=false" class="center bdc color">{{$t('m.CancelBtn')}}</div>
            <div @click="toLayoutBack()" class="right bdc color">{{$t('m.ResumeBtn')}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="pop" v-if="templatenameshow">
      <div class="templatepop">
        <div @click="closeallpop" class="popclosex">
          <Icon type="ios-close"></Icon>
        </div>
        <div class="templatepoptop">{{$t('m.SaveAsTemplate')}}</div>
        <div class="templatepopmiddle">
          <input :placeholder="$t('m.PlsEnterTemplateName')" type="text" v-model="templatename" />
        </div>
        <div @click="toSaveTemplate()" class="templatepopbottom color">{{$t('m.SaveBtn')}}</div>
      </div>
    </div>
    <div class="pop" v-if="broadcastshow">
      <div class="templatepop">
        <div @click="closeallpop" class="popclosex">
          <Icon type="ios-close"></Icon>
        </div>
        <div class="templatepoptop">{{$t('m.SelectBroacastTerminal')}}</div>
        <div class="templatepopmiddle">
          <Select clearable style="width:200px" v-model="value" @on-change="change">
            <Option
              v-for=" item in boradcastlist"
              :key="item.partyIdInWeMeet"
              :value="item.partyIdInWeMeet"
            >{{item.partyNameInWeMeet}}</Option>
          </Select>
        </div>
        <div @click="toBroadcast" class="templatepopbottom color">{{$t('m.Broadcast')}}</div>
      </div>
    </div>
    <div class="pop" v-if="exitsure">
      <div class="templatepopexit">
        <div class="popclosex" @click="exitsure=false">
          <Icon type="ios-close"></Icon>
        </div>
        <div class="title-line">
          <img class="iconimg" :src="confirmUrl" />
          <span class="title_sure">{{$t('m.CloseConfirm')}}</span>
        </div>
        <div class="templatepoptop">{{$t('m.ConfirmCloseMeeting')}}</div>
        <div @click="exitsure=false" class="templatepopbottomexit color bdc">{{$t('m.CancelBtn')}}</div>
        <div @click="toOverAll()" class="templatepopbottomexit bgc">{{$t('m.OKBtn')}}</div>
      </div>
    </div>
    <div class="pop" v-if="exitdansure">
      <div class="templatepopexit">
        <div class="popclosex" @click="exitdansure=false">
          <Icon type="ios-close"></Icon>
        </div>
        <div class="title-line">
          <img class="iconimg" :src="confirmUrl" />
          <span class="title_sure">{{$t('m.DeleteConfirmation')}}</span>
        </div>
        <div class="templatepoptop">{{$t('m.ConfirMDeleteParticipants')}}</div>
        <div @click="exitdansure=false" class="templatepopbottomexit color bdc">{{$t('m.CancelBtn')}}</div>
        <div @click="toOver()" class="templatepopbottomexit bgc">{{$t('m.OKBtn')}}</div>
      </div>
    </div>
    <div class="pop" v-if="shareplaysure">
      <div class="templatepopexit">
        <div class="popclosex" @click="shareplaysure=false">
          <Icon type="ios-close"></Icon>
        </div>
        <div class="title-line">
          <img class="iconimg" :src="confirmUrl" />
          <span class="title_sure">{{$t('m.LiveConfirm')}}</span>
        </div>
        <div class="templatepoptop">{{$t('m.OpenLiveAndShare')}}</div>
        <div @click="shareplaysure=false" class="templatepopbottomexit color bdc">{{$t('m.CancelBtn')}}</div>
        <div @click="liveshare()" class="templatepopbottomexit bgc">{{$t('m.OKBtn')}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import Header from "../header/header";

import {
  broadcast,
  callroll,
  layout,
  lockAPI,
  closeConf,
  radio,
  record,
  savetemplate,
  reConnectTerminal,
  video,
  doubleCurrentClean,
  beforeCreateMeeting,
  setLecture,
  unsetLecture,
  getMeetingDetails,
  stopcallroll,
  stopbroadcast,
  deleteParty
} from "../../assets/js/url.js";

export default {
  name: "meetingact",
  filters: {
    ellipsis(value) {
      if (!value) return "";
      if (value.length > 8) {
        return value.slice(0, 8) + "···";
      }
      return value;
    }
  },
  data() {
    return {
      confirmUrl: require("@/assets/images/public/confirm.png"),
      screen: [
        "1x1",
        "1x2",
        "2x1",
        "2x2",
        "3x3",
        "1x2"+this.$t('m.Vertical'),
        "1x2"+this.$t('m.Horizontal'),
        "2+1"+this.$t('m.Horizontal'),
        "2+1"+this.$t('m.Vertical'),
        "3+1"+this.$t('m.Horizontal'),
        "3+1"+this.$t('m.Vertical'),
        "4+1"+this.$t('m.Horizontal'),
        "4+1"+this.$t('m.Vertical'),
        "8+1"+this.$t('m.Upper'),
        "8+1"+this.$t('m.Middle'),
        "8+1"+this.$t('m.Bottom'),
        "2+1"+this.$t('m.HorizontalUP'),
        "3+1"+this.$t('m.HorizontalUP'),
        "4+1"+this.$t('m.HorizontalUP'),
        "7+1",
        "5+1",
        "4x4",
        "8+2",
        "12+1"
      ],
      screenshow: false,
      move: false,
      valueId: null,
      value: "",
      broadcastshow: false,
      oldlayouttype: 0,
      layouttype: 0,
      templatename: "",
      templatenameshow: false,
      sharevalue: "",
      redioaction: 1,
      videoaction: 1,
      overaction: 1,
      adduseruuid: 12334444,
      meetinguuid: "", //会议的cf_id  是设备上的id
      addterminalList: {},
      subMcuId: "",
      //双流状态
      doubleCurrentInfo: "",
      doubleCurrent: "",
      toOverActList: "",
      mcu_name: "",
      //增加会议室
      addterminaluuid: "",
      //会议名称
      mcu_name: "",
      terminallist: [],
      doublestreamactionName: "",
      //会议数据库id
      meetingId: "",
      terminallist: [],
      //以下是从会议中获取的详细信息
      cfparty: [],
      selectCfparty: [],
      cf_record: 1,
      conference_locked: "true",
      radio: "false",
      video: "false",
      mytime: null,
      // 搜索信息
      searchcontent: "",
      // 一键广播
      guangbo: false,
      mytimeout: null,
      exitsure: false,
      exitdansure: false,
      shareplaysure: false,
      actionuseruuids: null,
      //点击的终端设置主会场
      callRollInfo: "",
      callroll: "",
      Trmenalcallroll: false, //是否有终端处于点名状态
      boradcastlist: [],
      img: require("../../../static/img/0.png"),
      unLineimg: require("../../../static/img/1.png"),
      Muted: require("../../../static/img/2.png"),
      meetingInfo: {
        departmentId: "",
        cf_id: "",
        mcuId: ""
      },
      broadcastPolling: false,
      clickpolling: false,
      cfpartyTerminalIds: [],
      searchcfparty: [],
      showRecordAndLive: false,
      MeetingterminalList: [],
      terminal_total:0,
      terminal_on:0,
      vcesOnlyMeeting:false,
      vcesLecturer:false,  //是否设置了天宫终端为主会场，true时隐藏点名功能
      lecturer:false
    };
  },
  computed: {
    imgpath() {
      return this.$store.state.imagestyle[this.$store.state.cssstyle];
    },
    hasmediasuite() {
      return this.$store.state.hasmediasuite;
    }
  },
  components: {
    Header
  },
  mounted() {
    this.touchmove();
  },
  activated() {
    $("body>*").bind("click", function() {});
    var cfIdInQuery = this.$route.query.cfIdInWeMeet;
    var cfIdInStorage = window.sessionStorage.getItem("cfIdInWeMeet");
    if (cfIdInQuery) {
      if (cfIdInQuery != cfIdInStorage) {
        window.sessionStorage.setItem("cfIdInWeMeet", cfIdInQuery);
      }
    }
    this.meetingInfo.cf_id = this.$route.query.cf_id;
    this.meetingInfo.mcuId = this.$route.query.mcuId;
    this.cfparty = "";

    this.getMeetingIsShow();
    this.toGetForthMeeting();

    
    var refresh = window.sessionStorage.getItem("Time");
    if(refresh == null || !refresh || refresh <= 0)
    {
      refresh = 10;
    }

    this.mytime = setInterval(
      this.toGetForthMeeting,
      refresh * 1000
    );
  },
  beforeRouteLeave(to, from, next) {
    window.clearInterval(this.mytime);
    window.clearTimeout(this.mytimeout);
    this.mytimeout = null;
    this.mytime = null;
    next();
  },
  deactivated() {
    this.$destroy();
    clearInterval(this.mytime);
  },
  destroyed() {
    clearInterval(this.mytime);
  },
  methods: {
    getMeetingIsShow() {
      this.$http
        .post(beforeCreateMeeting, { time: Date.parse(new Date()) })
        .then(res => {
          if (res.data.status == 2000) {
            let data = res.data.data;
            this.showRecordAndLive = data.showRecordAndLive;
          }
        });
    },
    stopDoubleStream(item){
      if(window.confirm(this.$t('m.ConfirmStopDoubleStream'))){
        let that = this;
        let url = '/api/conference/grantContentPermit';
        let data = {
          cfIdInWeMeet: window.sessionStorage.getItem("cfIdInWeMeet"),
          partyIdInWeMeet: item.partyIdInWeMeet
        }
        this.$http
        .post(url, data).then(res => {
          if(res.data.status != 2000){
            this.$toast(res.data.data.errorDes);
          }else{
            this.toGetForthMeeting()
          }
        })
      }
    },
    toGetForthMeeting() 
    {
      const _this = this;
   
      this.$http
        .post(getMeetingDetails, {
          cfIdInWeMeet: window.sessionStorage.getItem("cfIdInWeMeet"),
          searchKey: this.searchcontent,
          isFromMobile: true
        })
        .then(
          res => {
            if (res.data.status == 2000) {
              const data = res.data.data;
              //会议数据库id
              _this.meetingId = data.id;
              _this.subMcuId = data.mcu_ID;
              _this.addterminalList.meetinguuid = data.cf_id;
              _this.addterminalList.parentMcuId = data.mcuId;
              _this.addterminalList.meetingId = data.id;
              //终端数据库中 id
              _this.terminalIds = data.cf_terminal_id;
              _this.video = data.videoMuted ? "true" : "false";
              _this.radio = data.audioMuted ? "true" : "false";
              _this.vcesOnlyMeeting = data.vcesOnlyMeeting;
              _this.layouttype = Number(data.layout);
              _this.oldlayouttype =  Number(data.layout);
              // 判断是否有点名终端
              for (let i = 0; i < data.cf_party.length; i++) {
                if (data.cf_party[i].callroll === "callrolling") {
                  this.Trmenalcallroll = true;
                  break;
                } else {
                  this.Trmenalcallroll = false;
                }
              }

              //判断是否有主会场
              for (let i = 0; i < data.cf_party.length; i++) {
                if (data.cf_party[i].lecturer) {
                  this.lecturer = true;
                  data.cf_party[i].onVces && (this.vcesLecturer = true)
                }
              }

              //将未连接状态和预监的终端列表中删除（广播/双流）
              this.boradcastlist = [];
              for (let i = 0; i < data.cf_party.length; i++) {
                if (
                  data.cf_party[i].connection_status == "connected" &&
                  !data.cf_party[i].supervisor
                ) {
                  this.boradcastlist.push(data.cf_party[i]);
                }
              }
              //通过列表，获取全部信息
              _this.cfparty = data.cf_party;
              //汇控终端的列表信息
              this.MeetingterminalList = [];
              _this.cfparty.map(item => {
                this.MeetingterminalList.push(Number(item.partyIdInWeMeet));
              });
              //广播轮询状态
              _this.guangbo = data.broadcast == "running" ? true : false;
              _this.clickpolling = data.keyPolling == "true" ? true : false;
              _this.broadcastPolling =
                data.broadcastPolling == "true" ? true : false;
              _this.cfparty.map(item => {
                item.connection_status.toLowerCase();
                if (item.connection_status.indexOf("connected") == 0) {
                  item.connection_status = "connected";
                }
                return item;
              });
			  
              _this.terminal_on = 0;
              for (let i = 0; i < _this.cfparty.length; i++) 
              {
                if (_this.cfparty[i].connection_status == "connected") 
                {
                  _this.terminal_on  ++;                
                }
              }
              _this.terminal_total =  _this.cfparty.length;
			  
              this.cfpartyTerminalIds = _this.cfparty.map(item => {
                return item.id;
              });
              _this.searchcfparty = data.cf_party;
              _this.callroll = data.callroll;
              _this.mcu_name = data.mcu_name;
              //双流状态
              _this.doubleCurrent = data.doubleCurrent;
              _this.doubleCurrentInfo = _this.cfparty.filter((item, index) => {
                return item.doubleCurrent == "true";
              })[0];
              //_this.cf_record=data.cf_record
              _this.conference_locked = data.conference_locked;
              // 会议录制状态
              if (data.record_status == "noaction") {
                _this.cf_record = 1;
              } else if (data.record_status == "start") {
                _this.cf_record = 2;
              } else if (data.record_status == "pause") {
                _this.cf_record = 4;
              } else {
                _this.cf_record = 1;
              }
              const layoutlist = [
                "1 cell", // 1
                "2 horizontal", // 2
                "2 vertical", // 3
                "2 horizontal by 2 vertical", // 4
                "3 horizontal by 3 vertical", //5
                "2 vertical tall", //6
                "2 horizontal wide", // 7
                "1 plus 2 top", // 8
                "1 plus 2 right", // 9
                "1 plus 3 top", // 10
                "1 plus 3 right", // 11
                "1 plus 4 top", // 12
                "1 plus 4 right", // 13
                "1 plus 4 bottom and 4 bottom", // 15
                "1 plus 4 top and 4 bottom", // 16
                "1 plus 4 top and 4 top", // 17
                "1 plus 2 bottom", // 18
                "1 plus 3 bottom", // 19
                "1 plus 4 bottom", // 20
                "1 plus 4 bottom and 3 right", // 21
                "1 plus 3 bottom and 2 right", // 22
                "4 horizontal by 4 vertical", //23
                "2 horizontal plus 4 top and 4 bottom", //23
                "1 center plus 4 top and 4 bottom and 2 right and 2 left" // 24
              ];
              // _this.layouttype = parseInt(data.layout);
              // if (layoutlist.indexOf(data.current_layout) == -1) {
              //   _this.oldlayouttype = 0;
              // } else {
              //   _this.oldlayouttype =
              //     layoutlist.indexOf(data.current_layout) + 1;
              // }
              let newarr = this.cfparty;
              let newarrCon = [];
              let newarrDiscon = [];
              for(let i=0;i<newarr.length;i++){
                if(newarr[i].connected){
                  newarrCon.push(newarr[i])
                }else{
                  newarrDiscon.push(newarr[i])
                }
              }
              this.cfparty = newarrCon.concat(newarrDiscon)
            } else {
              this.$router.push("/index");
            }
          },
          err => {}
        );
    },
    //分屏模式
    Splitscreen() {
      this.$loadingshow();
      this.$http
        .post(getMeetingDetails, {
          cfIdInWeMeet: window.sessionStorage.getItem("cfIdInWeMeet")
        })
        .then(res => {
          this.$loadingclose();
          if (res.data.status === 2000) {
            const data = res.data.data;
            this.layouttype = parseInt(data.layout);
          }
        });
    },
    liveshare() {
      if (!this.showRecordAndLive) {
        this.$toast(this.$t('m.NoRecordDevice'));
        return;
      }
      this.shareplaysure = false;
      this.$router.push({
        path: "/userlist",
        query: {
          canChoose: true,
          message: this.$store.state.meeting.cfparty, //要在通讯录中把人标出来
          isGetShareLive: true,
          cf_id: this.meetingInfo.cf_id,
          mcuId: this.meetingInfo.mcuId
        }
      });
    },
    closeallpop() {
      this.templatenameshow = false;
      this.broadcastshow = false;
    },
    search() {
      if (this.searchcontent) {
        this.cfparty = this.cfparty.filter(
          item => item.partyNameInWeMeet.indexOf(this.searchcontent) !== -1
        );
      } else {
        this.cfparty = this.searchcfparty;
      }
    },
    goback() {
      this.$router.go(-1);
    },
    //action1:增加人员
    addpeople() 
    {
      this.$router.push({
        path: "/userlist",
        query: {
          //没有属性name
          canChoose: true,
          cf_id: this.meetingInfo.cf_id,
          mcuId: this.meetingInfo.mcuId
        }
      });
    },
    //action2:增加终端
    addterminal() {
      this.$router.push({
        // path: '/terminaladd',
        name: "terminalcontrolPctest",
        query: {
          //没有属性name
          meetingId: this.meetingId, //会议的数据库id
          cf_id: this.meetingInfo.cf_id,
          mcuId: this.meetingInfo.mcuId,
          messageTerminal: this.cfpartyTerminalIds,
          MeetingterminalList: JSON.stringify(this.MeetingterminalList)
        },
        params: {
          meeting_vrmId: 0,
          creatingTime: ""
        }
      });
    },
    doublestream() {
      if (this.doubleCurrent == "true") {
        let data = this.cfparty.filter(item => {
          if (item.doubleCurrent == "true") {
            return item;
          }
        });
        this.$loadingshow();
        this.$http
          .post(doubleCurrentClean, {
            userUUid: window.sessionStorage.getItem("UUID"),
            cfIdInWeMeet: window.sessionStorage.getItem("cfIdInWeMeet"),
            partyIdInWeMeet: data[0].partyIdInWeMeet
          })
          .then(
            res => {
              this.$loadingclose();
              if (res.data.status == 2000) {
                this.$toast(this.$t('m.CanceledDualStreamSender'));
                this.toGetForthMeeting();
              } else {
                this.$toast(this.$t('m.CanceledDualStreamSenderFail'));
              }
            },
            err => {
              this.$loadingclose();
              this.$toast(this.$t('m.OperateFail'));
            }
          );
      } else {
        sessionStorage.setItem('_doublestreamCfpary',JSON.stringify(this.cfparty))
        this.$router.push({
          path: "/doublestream",
          query: {
            meetinguuid: this.meetinguuid,
            mcuId: this.meetingInfo.mcuId,
            cf_id: this.meetingInfo.cf_id,
            doublestreamTerminalId:this.doubleCurrentInfo?this.doubleCurrentInfo.partyIdInWeMeet:''
          },
          params: {
            doublestreamTerminal: this.doubleCurrentInfo
          }
        });
      }
    },

    checkinrecords() {
      this.$router.push({
        path: "/checkinrecords",
        query: {
          id: this.meetingId
        }
      });
    },
    touchmove() {
      const _this = this;
      const mybody = document.getElementById("content");
      let startX, startY, moveEndX, moveEndY, X, Y;
      mybody.addEventListener(
        "touchstart",
        function(e) {
          // e.preventDefault();
          if(_this.vcesOnlyMeeting){
            _this.move = false;
            return false
          }
          startX = e.touches[0].pageX;
          startY = e.touches[0].pageY;
        },
        false
      );
      mybody.addEventListener("touchmove", function(e) {
        // e.preventDefault();
        if(_this.vcesOnlyMeeting){
            _this.move = false;
            return false
          }
        moveEndX = e.changedTouches[0].pageX;
        moveEndY = e.changedTouches[0].pageY;
        X = moveEndX - startX;
        Y = moveEndY - startY;
        if (Math.abs(X) > Math.abs(Y) && X > 0) {
          // right
          _this.move = false;
        } else if (Math.abs(X) > Math.abs(Y) && X < 0) {
          // left
          _this.move = true;
        } else if (Math.abs(Y) > Math.abs(X) && Y > 0) {
          // down
        } else if (Math.abs(Y) > Math.abs(X) && Y < 0) {
          // up
        } else {
          // 没有发生滑动
        }
      });
    },
    // 点名接口
    setChair(item) {
      this.$loadingshow();
      this.$http
        .post(callroll, {
          cfIdInWeMeet: window.sessionStorage.getItem("cfIdInWeMeet"),
          partyIdInWeMeet: item.partyIdInWeMeet
        })
        .then(
          res => {
            this.$loadingclose();
            if (res.data.status == 2000) {
              this.$toast(this.$t('m.RollCallSuccessful'));
              this.toGetForthMeeting();
            } else {
              this.$toast(this.$t('m.RollCallFailed'));
            }
          },
          err => {
            this.$loadingclose();
            this.$toast(this.$t('m.OperateFail'));
          }
        );
    },
    // 取消点名保留主会场
    cancelroll(item) {
      this.$loadingshow();
      this.$http
        .post(stopcallroll, {
          cfIdInWeMeet: window.sessionStorage.getItem("cfIdInWeMeet"),
          partyIdInWeMeet: item.partyIdInWeMeet
        })
        .then(
          res => {
            this.$loadingclose();
            if (res.data.status == 2000) {
              this.$toast(this.$t('m.RollCallCancelledSuccessfully'));
              this.toGetForthMeeting();
            } else {
              this.$toast(this.$t('m.RollCallCancelledFail'));
            }
          },
          err => {
            this.$loadingclose();
            this.$toast(this.$t('m.OperateFail'));
          }
        );
    },
    // 设置主会场接口
    setLecture(item) {
      this.$loadingshow();
      this.$http
        .post(setLecture, {
          cfIdInWeMeet: window.sessionStorage.getItem("cfIdInWeMeet"),
          partyIdInWeMeet: item.partyIdInWeMeet
        })
        .then(
          res => {
            this.$loadingclose();
            if (res.data.status == 2000) {
              this.lecturer = true;
              if(item.onVces){
                this.vcesLecturer = true;
              }else{
                this.vcesLecturer = false;
              }
              this.$toast(this.$t('m.SetUpTheMainVenueOK'));
              this.toGetForthMeeting();
            } else {
              this.$toast(this.$t('m.SetUpTheMainVenueFail'));
            }
          },
          err => {
            this.$loadingclose();
            this.$toast(this.$t('m.OperateFail'));
          }
        );
    },
    //  取消主会场
    unsetLecture(item) {
      this.$loadingshow();
      this.$http
        .post(unsetLecture, {
          cfIdInWeMeet: window.sessionStorage.getItem("cfIdInWeMeet"),
          partyIdInWeMeet: item.partyIdInWeMeet
        })
        .then(
          res => {
            this.$loadingclose();
            if (res.data.status == 2000) {
              this.vcesLecturer = false;
              this.lecturer = false;
              this.$toast(this.$t('m.MainVenueCancelledSuccessfully'));
              this.toGetForthMeeting();
            } else {
              this.$toast(this.$t('m.MainVenueCancelledFail'));
            }
          },
          err => {
            this.$loadingclose();
            this.$toast(this.$t('m.OperateFail'));
          }
        );
    },

    // 设置主会场
    setMeeting(callroll, item) {
      //广播情况下不能点名
      if (this.guangbo) {
        this.$toast(this.$t('m.BroadcastStatusCanNotSetHost'));
        return;
      }
      if (this.clickpolling || this.broadcastPolling) {
        this.$toast(this.$t('m.PollStatusCanNotSetHost'));
        return;
      }
      if (this.Trmenalcallroll && item.callroll != "callrollmain") {
        this.$toast(this.$t('m.CallrollCanNotSetHost'));
      } else {
        // 设置主会场
        if (callroll != "callrollmain") {
          this.setLecture(item);
        }
      }
      // 取消主会场
      if (callroll == "callrollmain") {
        this.unsetLecture(item);
      }
    },
    // 点名逻辑
    callRoll(callroll, item) {
      // 没有主会场无法进行点名
      if (!this.lecturer) {
        this.$toast(this.$t('m.NoHostNoCallroll'));
      }
      // 当有主会场时，对其他终端进行点名
      if (this.callroll !== "notcallroll" && callroll !== "callrollmain") {
        if (callroll != "callrolling") {
          this.setChair(item);
        }
        if (callroll == "callrolling") {
          this.cancelroll(item);
        }
      }
    },
    change(e) {
      this.valueId = e;
    },
    //取消一键广播
    broadcastShowAct() {
      if (this.callroll == "callrolling") {
        this.$toast(this.$t('m.CallrollCanNotBroadcast'));
        return;
      }
      if (this.clickpolling || this.broadcastPolling) {
        this.$toast(this.$t('m.PollStatusCanNotBroadcast'));
        return;
      }
      this.$http
        .post(beforeCreateMeeting, { time: Date.parse(new Date()) })
        .then(res => {
          if (res.data.status == 2000) {
            let data = res.data.data;
            this.showRecordAndLive = data.showRecordAndLive;
          }
        });
      if (this.guangbo) {
        this.$loadingshow();
        this.$http
          .post(stopbroadcast, {
            cfIdInWeMeet: window.sessionStorage.getItem("cfIdInWeMeet"),
            partyIdInWeMeet: this.valueId
          })
          .then(
            res => {
              this.$loadingclose();
              if (res.data.status == 2000) {
                this.broadcastshow = false;
                this.guangbo = false;
                this.$toast(this.$t('m.OneKeyBroadcastCancelOK'));
                this.toGetForthMeeting();
              } else {
                this.broadcastshow = false;
                this.$toast(this.$t('m.OneKeyBroadcastCancelFail'));
              }
            },
            err => {
              this.broadcastshow = false;
              this.$toast(this.$t('m.CancelFail'));
            }
          );
      } else {
        this.value = "";
        this.broadcastshow = true;
      }
    },
    // 一键广播
    toBroadcast() {
      this.$http
        .post(beforeCreateMeeting, { time: Date.parse(new Date()) })
        .then(res => {
          if (res.data.status == 2000) {
            let data = res.data.data;
            this.showRecordAndLive = data.showRecordAndLive;
          }
        });
      this.$loadingshow();
      this.$http
        .post(broadcast, {
          cfIdInWeMeet: window.sessionStorage.getItem("cfIdInWeMeet"),
          partyIdInWeMeet: this.valueId
        })
        .then(
          res => {
            this.$loadingclose();
            if (res.data.status == 2000) {
              this.broadcastshow = false;
              this.guangbo = true;
              this.$toast(this.$t('m.BroadcastOK'));
              this.toGetForthMeeting();
            } else {
              this.broadcastshow = false;
              this.$toast(res.data.data.errorDes || this.$t('m.BroadcastFail'));
            }
          },
          err => {
            this.broadcastshow = false;
            this.$toast(this.$t('m.BroadcastFail'));
          }
        );
    },
    //挂断 但是不退出
    toHangUp(item) {
      let ifInRmx = item.ifInRmx;
      let terminal = "";
      if (ifInRmx == 0) {
        terminal = item.id;
      } else {
        terminal = item.partyIdInWeMeet;
      }
      if (item.connection_status == "disconnected") {
        this.$loadingshow();
        this.$http
          .post(reConnectTerminal, {
            useruuid: window.sessionStorage.getItem("UUID"),
            cfIdInWeMeet: window.sessionStorage.getItem("cfIdInWeMeet"),
            partyIdInWeMeet: item.partyIdInWeMeet,
            action: "true"
          })
          .then(res => {
            this.$loadingclose();
            if (res.data.status === 2000) {
              this.$toast(this.$t('m.ConnectOK'));
              this.toGetForthMeeting();
            } else {
              this.$toast(this.$t('m.ConnectFail'));
            }
          });
      } else {
        this.$loadingshow();
        this.$http
          .post(reConnectTerminal, {
            useruuid: window.sessionStorage.getItem("UUID"),
            cfIdInWeMeet: window.sessionStorage.getItem("cfIdInWeMeet"),
            partyIdInWeMeet: item.partyIdInWeMeet,
            action: "false"
          })
          .then(res => {
            this.$loadingclose();
            if (res.data.status === 2000) {
              this.$toast(this.$t('m.DisconnectOK'));
              this.toGetForthMeeting();
            } else {
              this.$toast(this.$t('m.DisconnectFail'));
            }
          });
      }
    },
    toLayout() {
      this.$loadingshow();
      let params = {
        cfIdInWeMeet: window.sessionStorage.getItem("cfIdInWeMeet"),
        userUUId: window.sessionStorage.getItem("UUID"),
        layoutType: this.layouttype
      };
      this.$http.post(layout, params).then(
        res => {
          this.$loadingclose();
          if (res.data.status === 2000) {
            this.screenshow = false;
            this.$toast(this.$t('m.LayoutOK'));
            this.Splitscreen();
            this.initradio("screen", this.layouttype);
            this.oldlayouttype = this.layouttype;
          } else {
            this.screenshow = false;
            this.$toast(this.$t('m.LayoutFail'));
          }
        },
        err => {
          this.screenshow = false;
          this.$toast(this.$t('m.LayoutFail'));
        }
      );
    },
    //选中之后勾选默认分屏值
    initradio(rName, rValue) {
      var rObj = document.getElementsByName(screen);
      for (var i = 0; i < rObj.length; i++) {
        if (rObj[i].value == rValue) {
          rObj[i].checked = "checked";
        }
      }
    },
    toLayoutBack() {
      this.$loadingshow();
      this.$http
        .post(layout, {
          cfIdInWeMeet: window.sessionStorage.getItem("cfIdInWeMeet"),
          userUUId: window.sessionStorage.getItem("UUID"),
          layoutType: 25
        })
        .then(
          res => {
            this.$loadingclose();
            if (res.data.status === 2000) {
              this.screenshow = false;
              this.$toast(this.$t('m.LayoutResumeOK'));
              this.Splitscreen();
              this.layouttype = 0;
              this.oldlayouttype = 0;
            } else {
              this.screenshow = false;
              this.$toast(this.$t('m.LayoutResumeFail'));
            }
          },
          err => {
            this.screenshow = false;
            this.$toast(this.$t('m.LayoutResumeFail'));
          }
        );
    },
    //存为模板
    toSaveTemplate() {
      if (!this.templatename) {
        this.$toast(this.$t('m.PlsEnterTemplateName'));
        return;
      }
      this.$loadingshow();
      this.$http
        .post(savetemplate, {
          userUUid: window.sessionStorage.getItem("UUID"),
          cfIdInWeMeet: window.sessionStorage.getItem("cfIdInWeMeet"),
          templateName: this.templatename
        })
        .then(
          res => {
            this.$loadingclose();
            if (res.data.status == 2000) {
              this.templatenameshow = false;
              this.templatename = "";
              this.$toast(this.$t('m.SaveTemplateOK'));
              this.toGetForthMeeting();
            } else {
              this.templatenameshow = false;
              this.$toast(this.$t('m.SaveTemplateFail'));
            }
          },
          err => {
            this.$loadingclose();
            this.templatenameshow = false;
            this.$toast(this.$t('m.SaveTemplateFail'));
          }
        );
    },
    toRadio(item) {
      this.$loadingshow();
      this.$http
        .post(radio, {
          userUUid: window.sessionStorage.getItem("UUID"),
          cfIdInWeMeet: window.sessionStorage.getItem("cfIdInWeMeet"),
          partyIdInWeMeet: item.partyIdInWeMeet,
          action: item.audioMuted ? "false" : "true"
        })
        .then(res => {
          this.$loadingclose();
          if (res.data.status == 2000) {
            if (item.audioMuted) {
              this.$toast(this.$t('m.AudioOn'));
            } else {
              this.$toast(this.$t('m.AudioOff'));
            }
            this.toGetForthMeeting();
            // const _this = this;
            // setTimeout(function() {
            //   _this.toGetForthMeeting();
            // }, 1000);
          } else {
            this.$toast(this.$t('m.OperateFail'));
          }
        });
    },
    toRadioAll() {
      this.$loadingshow();
      this.$http
        .post(radio, {
          userUUid: window.sessionStorage.getItem("UUID"),
          cfIdInWeMeet: window.sessionStorage.getItem("cfIdInWeMeet"),
          partyIdInWeMeet: "",
          action: this.radio === "false" ? "true" : "false"
        })
        .then(res => {
          this.$loadingclose();
          if (res.data.status == 2000) {
            if (this.radio == "true") {
              this.$toast(this.$t('m.AllAudioOn'));
              this.radio = "false";
            } else {
              this.$toast(this.$t('m.AllAudioOff'));
              this.radio = "true";
            }
            const _this = this;
            setTimeout(function() {
              _this.toGetForthMeeting();
            }, 1000);
          } else {
            this.$toast(this.$t('m.OperateFail'));
          }
        });
    },
    toVideo(item) {
      this.$loadingshow();
      this.$http
        .post(video, {
          userUUid: window.sessionStorage.getItem("UUID"),
          cfIdInWeMeet: window.sessionStorage.getItem("cfIdInWeMeet"),
          partyIdInWeMeet: item.partyIdInWeMeet,
          action: item.videoMuted ? "false" : "true"
        })
        .then(res => {
          this.$loadingclose();
          if (res.data.status == 2000) {
            if (item.videoMuted) {
              this.$toast(this.$t('m.VideoOn'));
            } else {
              this.$toast(this.$t('m.VideoOff'));
            }
            this.toGetForthMeeting();
            // const _this = this;
            // setTimeout(function() {
            //   _this.toGetForthMeeting();
            // }, 1000);
          } else {
            this.$toast(this.$t('m.OperateFail'));
          }
        });
    },
    toVideoAll() 
    {
      this.$loadingshow();    
      this.$http
        .post(video, 
        {
          userUUid: window.sessionStorage.getItem("UUID"),
          cfIdInWeMeet: window.sessionStorage.getItem("cfIdInWeMeet"),
          partyIdInWeMeet: "",
          action: this.video === "true" ? "false" : "true"
        })
        .then(res => {
          this.$loadingclose();
          if (res.data.status == 2000)
           {
            if (this.video == "true") 
            {
              this.$toast(this.$t('m.AllVideoOn'));
              this.video = "false";
            } else 
            {
              this.$toast(this.$t('m.AllVideoOff'));
              this.video = "true";
            }
            const _this = this;
            setTimeout(function() 
            {
              _this.toGetForthMeeting();
            }, 1000);
          } else 
          {
            this.$toast(this.$t('m.OperateFail'));
          }
        });
    },
    toRecord(Recordingstatus) {
      if (!this.showRecordAndLive) {
        this.$toast(this.$t('m.NoRecordDeviceNoThisFunction'));
        return;
      }
      this.$loadingshow();
      this.$http
        .post(record, {
          userUUid: window.sessionStorage.getItem("UUID"),
          cfIdInWeMeet: window.sessionStorage.getItem("cfIdInWeMeet"),
          action: Recordingstatus
        })
        .then(res => {
          this.$loadingclose();
          if (res.data.status == 2000) {
            if (Recordingstatus == 1) {
              this.$toast(this.$t('m.MeetingStartRecord'));
              this.cf_record = 2;
            } else if (Recordingstatus == 2) {
              this.$toast(this.$t('m.MeetingSuspendedRecord'));
              this.cf_record = 4;
            } else if (Recordingstatus == 4) {
              this.$toast(this.$t('m.MeetingResumeRecord'));
              this.cf_record = 2;
            } else if (Recordingstatus == 3) {
              this.$toast(this.$t('m.MeetingEndRecord'));
              this.cf_record = 1;
            }
            this.toGetForthMeeting();
          } else {
            this.$toast(this.$t('m.OperateFail'));
          }
        });
    },
    toLock() {
      this.$loadingshow();
      this.$http
        .post(lockAPI, {
          userUUid: window.sessionStorage.getItem("UUID"),
          cfIdInWeMeet: window.sessionStorage.getItem("cfIdInWeMeet"),
          action: this.conference_locked === "false" ? "true" : "false"
        })
        .then(res => {
          this.$loadingclose();
          if (res.data.status == 2000) {
            if (this.conference_locked == "false") {
              this.$toast(this.$t('m.MeetingStartLock'));
            } else {
              this.$toast(this.$t('m.MeetingStartUnlock'));
            }
            this.toGetForthMeeting();
          } else {
            this.$toast(
              `${
                this.conference_locked == "false"
                  ? this.$t('m.MeetingLockFail')
                  : this.$t('m.MeetingUnlockFail')
              }`
            );
          }
        });
    },
    toOverAct(ac, item) {
      this.actionuseruuids = ac;
      this.toOverActList = item;
      this.exitdansure = true;
    },
    toOver() {
      this.$loadingshow();
      this.$http
        .post(deleteParty, {
          useruuid: window.sessionStorage.getItem("UUID"),
          cfIdInWeMeet: window.sessionStorage.getItem("cfIdInWeMeet"),
          partyIdInWeMeet: this.toOverActList.partyIdInWeMeet
        })
        .then(res => {
          this.$loadingclose();
          if (res.data.status == 2000) {
            this.$toast(this.$t('m.DeleteTerminalOK'));
            this.toGetForthMeeting();
          } else {
            this.$toast(res.data.data || this.$t('m.OperateFail'));
          }
          this.exitdansure = false;
        });
    },
    toOverAll() {
      this.$loadingshow();
      this.exitsure = false;
      this.$http
        .post(closeConf, {
          useruuid: window.sessionStorage.getItem("UUID"),
          cfIdInWeMeet: window.sessionStorage.getItem("cfIdInWeMeet")
        })
        .then(res => {
          this.$loadingclose();
          if (res.data.status === 2000) {
            const _this = this;
            this.$toast(this.$t('m.CloseMeetingOK'));
            window.sessionStorage.removeItem("cfIdInWeMeet");
            this.mytimeout = setTimeout(function() {
              _this.$router.push({ path: "/forthmeetingvmr" });
            }, 1000);
          } else {
            this.$toast(this.$t('m.CloseMeetingFail'));
          }
        });
    }
  }
};
</script>
<style scoped>
.serch {
  height: 0.4rem;
  line-height: 0.4rem;
  padding: 0 0.15rem;
  font-size: 0.15rem;
  width: 100%;
  background: #fff;
  position: fixed;
  /* top: 0; */
  left: 0;
  z-index: 100;
  border-bottom: 1px solid #f2f1f1;
}

input {
  background: transparent;
}

.serchbox {
  width: 1.9rem;
  height: 0.32rem;
  line-height: 0.32rem;
  display: inline-block;
  margin-top: 0.1rem;
  border-radius: 5px;
  border: 1px solid #fff;
  /* float: left; */
  margin-right: 0.08rem;
  box-sizing: border-box;
  padding: 0 0.1rem;
}
.lanceserchbox {
  width: 1.9rem;
  height: 0.16rem;
  line-height: 0.16rem;
  display: inline-block;
  border-radius: 5px;
  border: 1px solid #fff;
  margin-right: 0.05rem;
  box-sizing: border-box;
  display: inline-block;
}
.searchinput {
  width: 1.4rem;
  height: 0.32rem;
  border: none;
  background-color: transparent;
  outline: none;
  line-height: 0.32rem;
}

i {
  font-size: 0.2rem;
}

.btnwarp {
  width: 100%;
  position: fixed;
  left: 0;
  bottom: 0.28rem;
}

.point {
  width: 100%;
  height: 0.28rem;
  position: fixed;
  left: 0;
  bottom: 0rem;
  line-height: 0.28rem;
  text-align: center;
  font-size: 8px;
}

.point i {
  font-size: 8px;
}

.row {
  width: 100%;
  height: 0.55rem;
  line-height: 0.55rem;
  padding: 0 0.1rem;
  border-bottom: 1px solid #ddd;
}

.head {
  width: 0.3rem;
  height: 0.3rem;
  vertical-align: top;
  margin-right: 0.1rem;
  border-radius: 100%;
  display: inline-block;
  margin-top: 0.1rem;
}
.lacehead {
  width: 0.18rem;
  height: 0.18rem;
  vertical-align: middle;
  margin-right: 0.1rem;
  border-radius: 100%;
}

.name {
  width: 18%;
  height: 0.55rem;
  font-size: 0.14rem;
  color: #505050;
  display: inline-block;
  line-height: 0.55rem;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.imgicon {
  display: inline-block;
  width: 0.3rem;
  height: 0.3rem;
  vertical-align: middle;
}

.operate {
  float: right;
  height: 0.55rem;
}

.bottom {
  height: 1.9rem;
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  background-color: #fff;
  box-shadow: 0 -4px 20px 0 #ddd;
  overflow: hidden;
  z-index: 100;
  font-size: 12px;
}
.Bottom {
  height: 0.8rem;
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  background-color: #fff;
  box-shadow: 0 -4px 20px 0 #ddd;
  overflow: hidden;
  z-index: 100;
  font-size: 12px;
}

.b_content {
  width: 200%;
  height: 1.9rem;
  transition: all 0.5s;
}

.peoplelist {
  height: 4.5rem;
  overflow-y: scroll;
  font-size: 12px;
}

.bleft {
  padding: 0.05rem 0.2rem;
  box-sizing: border-box;
  height: 1.9rem;
  width: 50%;
  float: left;
}
.bright {
  padding: 0.05rem 0.2rem;
  box-sizing: border-box;
  height: 1.9rem;
  width: 50%;
  float: right;
}

.bitem {
  height: 0.7rem;
  width: 24%;
  margin-top: 0.1rem;
  display: inline-block;
  text-align: center;
}

.bitemimg {
  height: 0.45rem;
  width: 0.45rem;
  display: inline-block;
}

.bfont {
  width: 100%;
  display: inline-block;
}

.pointtwo {
  position: absolute;
  height: 0.2rem;
  line-height: 0.2rem;
  left: 0;
  width: 100%;
  bottom: 0;
  text-align: center;
}

.divpoint {
  width: 0.1rem;
  height: 0.1rem;
  vertical-align: middle;
  display: inline-block;
  border-radius: 100%;
  margin: 0 0.05rem;
  background: #ddd;
}

.pop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  color: #3b3b3b;
}

.popwarp {
  width: 3.46rem;
  height: 5rem;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-left: -1.73rem;
  margin-top: -2.5rem;
  background: #fff;
  border-radius: -7px;
  overflow-y: scroll;
  border-radius: 10px;
}

.popcontent {
  width: 3.46rem;
  height: 5rem;
  border-radius: -7px;
  padding: 0.1rem;
  box-sizing: border-box;
}

.popcontent .poptitle {
  height: 0.4rem;
  font-size: 0.16rem;
  line-height: 0.3rem;
  text-align: center;
}

.popcontent .screenpopmain {
  height: 3.8rem;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  overflow-y: scroll;
}

.screenpopmain .screenpopmainitem {
  width: 0.7rem;
  height: 0.9rem;
}

.screenimg {
  width: 0.36rem;
  height: 0.36rem;
  margin: 0 auto;
}

.screenfont {
  height: 0.3rem;
  line-height: 0.3rem;
  text-align: center;
  font-size: 0.12rem;
}

.screenradio {
  text-align: center;
}

.popfooter {
  height: 0.6rem;
  width: 100%;
  text-align: center;
  position: absolute;
  bottom: 0;
  left: 0;
  font-size: 14px;
}

.popfooter .left,
.popfooter .center,
.popfooter .right {
  min-width: 0.8rem;
  height: 0.38rem;
  display: inline-block;
  border-radius: 3px;
  line-height: 0.38rem;
  text-align: center;
  margin: 0.05rem;
  padding:0 0.1rem
}

.popfooter .left {
  color: #fff;
}

.templatepop {
  width: 2.7rem;
  height: 1.7rem;
  background-color: #fff;
  border-radius: 5px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -0.85rem;
  margin-left: -1.35rem;
  box-sizing: border-box;
  padding: 0.2rem;
}

.templatepopexit {
  width: 2.7rem;
  height: auto;
  background-color: #fff;
  border-radius: 5px;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -0.6rem;
  margin-left: -1.35rem;
  box-sizing: border-box;
  padding: 0.2rem 0.1rem;
  text-align: center;
  font-size: 14px;
}
.templatepopexit .title-line {
  text-align: left;
}
.templatepopexit .iconimg {
  width: 20px;
  height: 20px;
  vertical-align: middle;
}
.templatepopexit .title_sure {
  margin-left: 0.03rem;
  font-weight: bold;
}

.templatepoptop {
  height: 0.4rem;
  text-align: center;
  line-height: 0.4rem;
  font-size: 14px;
}

.templatepopmiddle {
  height: 0.5rem;
  line-height: 0.5rem;
  border-radius: 5px;
  background: #f6f7fa;
  text-align: center;
  font-size: 14px;
}

.templatepopmiddle input {
  width: 2rem;
  height: 0.4rem;
  border: none;
  outline: none;
  vertical-align: middle;
  background: transparent;
  font-size: 14px;
}

.templatepopbottom {
  margin-top: 0.1rem;
  border-top: 1px solid #eee;
  text-align: center;
  height: 0.4rem;
  line-height: 0.4rem;
  font-size: 0.14rem;
}

.templatepopbottomexit {
  margin: 0.1rem 0.1rem 0;
  color: #fff;
  text-align: center;
  height: 0.3rem;
  width: 0.6rem;
  border-radius: 3px;
  display: inline-block;
  line-height: 0.3rem;
}

.bleft .bitem:nth-child(7) .bitemimg.no {
  background: url("../../assets/images/redicon/novoice.png") no-repeat center
    center !important;
  background-size: 0.36rem 0.36rem !important;
}

.bleft .bitem:nth-child(8) .bitemimg.no {
  background: url("../../assets/images/redicon/novideo.png") no-repeat center
    center !important;
  background-size: 0.36rem 0.36rem !important;
}

.bleft .bitem:nth-child(9) .bitemimg {
  background: url("../../assets/images/redicon/locked.png") no-repeat center
    center !important;
  background-size: 0.36rem 0.36rem !important;
}

.bleft .bitem:nth-child(4) .bitemimg.no {
  background: url("../../assets/images/wemeeticons/broadcastno.png") no-repeat
    center center;
  background-size: 0.36rem 0.36rem;
}

.bright .bitem:nth-child(3) .bitemimg {
  background: url("../../assets/images/redicon/locked.png") no-repeat center
    center !important;
  background-size: 0.36rem 0.36rem !important;
}

.bright .bitem:nth-child(4) .bitemimg {
  background: url("../../assets/images/redicon/close.png") no-repeat center
    center !important;
  background-size: 0.36rem 0.36rem !important;
}

.bright .bitem:nth-child(4) .bitemimg.none {
  background: url("../../assets/images/redicon/over.png") no-repeat center
    center !important;
  background-size: 0.36rem 0.36rem !important;
}

.hangup {
  background: url("../../assets/images/redicon/close.png") no-repeat left center !important;
  background-size: 0.22rem 0.23rem !important;
}

.voice.no {
  background: url("../../assets/images/redicon/novoice.png") no-repeat center
    center !important;
  background-size: 0.23rem 0.23rem !important;
}

.video.no {
  background: url("../../assets/images/redicon/novideo.png") no-repeat center
    center !important;
  background-size: 0.23rem 0.23rem !important;
}
.hangupStatus.no {
  background: url("../../assets/images/hangup/black/2.png") no-repeat center
    center !important;
  background-size: 0.23rem 0.23rem !important;
}

.popclosex {
  position: absolute;
  top: 0.1rem;
  right: 0.1rem;
  font-size: 14px;
}

.bitemimg_new {
  height: 0.35rem;
  width: 0.35rem;
  display: inline-block;
  margin-bottom: 8px;
}
.Bitemimg_new {
  height: 0.3rem;
  width: 0.3rem;
  display: inline-block;
  margin-bottom: 8px;
}
.noSetDoubleCurrent {
  display: none;
}
.SetDoubleCurrent {
  display: inline-block;
  width: 0.3rem;
  height: 0.3rem;
  vertical-align: middle;
  background: url("../../assets/images/redicon/shuangliu.png") no-repeat center
    center !important;
  background-size: 0.23rem 0.23rem !important;
}
/* 横屏 */
.B_content {
  width: 200%;
  height: 0.7rem;
  transition: all 0.5s;
}
.Bleft,
.Bright {
  padding: 0.1rem 0.4rem;
  box-sizing: border-box;
  width: 50%;
  float: left;
}

.Bitem {
  height: 0.5rem;
  width: 11.5%;
  margin-top: 0.05rem;
  display: inline-block;
  text-align: center;
}
.lanceserch {
  height: 0.26rem;
  line-height: 0.26rem;
  padding: 0 0.15rem;
  font-size: 0.1rem;
  width: 100%;
  background: #fff;
  position: fixed;
  left: 0;
  z-index: 100;
}
.lancepointtwo {
  position: absolute;
  height: 0.2rem;
  line-height: 0.2rem;
  left: 0;
  width: 100%;
  bottom: 0;
  text-align: center;
}
.lancedivpoint {
  width: 0.1rem;
  height: 0.1rem;
  vertical-align: middle;
  display: inline-block;
  border-radius: 100%;
  margin: 0 0.05rem;
  background: #ddd;
}
</style>




// WEBPACK FOOTER //
// src/components/content/meetingact.vue